export const isDevelopment = () => {
  return process.env.NEXT_PUBLIC_STAGE === 'DEV';
};
